<!-- Items Detail Page will display here -->

<div class="container-fluid">
    <div class="row">
        <div class="col-lg-8 col-xl-9 col-md-12 col-xs-12 col-sm-12 col-12">    
            <div class="card" id="s_itemdetail" style="margin-top: 5rem;">
                <div class="card-body">
                        <zsd-serviceitemsdetail></zsd-serviceitemsdetail>
                </div>
            </div>
        </div>    
        <div class="col-lg-4 col-xl-3 d-none d-lg-block d-xl-block">    
                <div class="card" id="s_itemrelatedrequests" style="margin-top: 5rem;">
                    <div class="card-body"  id="s_item_related_requests_card">
                         <zsd-serviceitemsrelatedrequest></zsd-serviceitemsrelatedrequest>
                    </div>
                </div>
            </div>    
    </div>
</div>